import React, { useState } from 'react'
import MainModal from './MainModal'

const ModalController = () => {
  const [modalVisible, setModalVisible] = useState(true)

  if (
    window.location.pathname.includes('auth/login') ||
    window.location.pathname.includes('auth/phone_auth') ||
    window.location.pathname.includes('auth/pw-reset-step1') ||
    window.location.pathname.includes('auth/id-find')
  ) {
    return null
  }

  const closeModal = () => {
    setModalVisible(false)
  }

  return (
    <div>
      {modalVisible && (
        <MainModal visible={modalVisible} closable={true} maskClosable={true} onClose={closeModal}></MainModal>
      )}
    </div>
  )
}

export default ModalController
